import axios from 'axios'
require('dotenv/config')

const api = axios.create({
  baseURL: 'https://api.toor.com.br/',
  // baseURL: process.env.REACT_APP_API,
})

export default api
